import TabNav from "common/components/TabNav"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { TABS } from "./constants"
import "./styles.scss"

const Informes = () => {
  const { t } = useTranslation()
  const [tabSelected, setTabSelected] = useState(null)

  const history = useHistory()

  useEffect(() => {
    const {
      location: { pathname },
    } = history
    const selected = TABS(t).find((tab) => tab.key === pathname)

    // @ts-expect-error TS(2345): Argument of type '{ key: string; header: string; C...
    setTabSelected(selected)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history])

  const handleChangeTab = (tabSelectedId: $TSMigrationFixMe) => {
    const selected = TABS(t).find((tab) => tab.id === tabSelectedId)
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    history.push(selected.key)
    // @ts-expect-error TS(2345): Argument of type '{ key: string; header: string; C...
    setTabSelected(selected)
  }

  return (
    <div className='tw-h-full'>
      <div className='tw-px-6 tw-py-4 tw-text-2xl tw-text-left tw-bg-simple-10 tw-font-medium'>
        {t("informes.title")}
      </div>
      <div className='tw-px-6 tw-pb-4 tw-bg-simple-10 tw-shadow-md tw-mb-1'>
        <TabNav
          tabs={TABS(t)}
          // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
          active={tabSelected?.id}
          setActive={handleChangeTab}
        />
      </div>
      {TABS(t).map((tab) => (
        // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
        <>{tab.id === tabSelected?.id && <tab.Component />}</>
      ))}
    </div>
  )
}

export default Informes
